import { render, staticRenderFns } from "./LiveLists.vue?vue&type=template&id=1722b707&scoped=true&"
import script from "./LiveLists.vue?vue&type=script&lang=js&"
export * from "./LiveLists.vue?vue&type=script&lang=js&"
import style0 from "./LiveLists.vue?vue&type=style&index=0&id=1722b707&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1722b707",
  null
  
)

export default component.exports